import { SAFE_URL_RE } from './SAFE_URL_RE';

export const isSafeUrl = (url: string): boolean => SAFE_URL_RE.test(url.trim());
